/**
 * Infinity Collectables – Collection Grid View Toggle + AJAX Add-to-Cart
 * assets/ic-grid-toggle.js
 *
 * Dawn grid system notes:
 *  - #product-grid is a <ul> with flexbox layout (NOT CSS grid)
 *  - Column width is set via width on .grid__item
 *  - Dawn's classes: grid--2-col-tablet-down, grid--4-col-desktop etc.
 *  - We ADD grid--view-1/3/5 classes that our CSS uses to override widths
 *  - MutationObserver re-applies view after facet AJAX re-renders
 *  - Saved in localStorage under 'ic_grid_view', default: '3'
 */
(function () {
  'use strict';

  var STORAGE_KEY  = 'ic_grid_view';
  var DEFAULT_VIEW = '3';
  var MOBILE_BP    = 750;

  /* ── helpers ─────────────────────────────────────────────────────── */
  function isMobile() {
    return window.innerWidth < MOBILE_BP;
  }

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function getToolbar() {
    return document.getElementById('ic-grid-toolbar');
  }

  /* ── apply a view to the grid ────────────────────────────────────── */
  function applyView(v, grid, toolbar) {
    if (!grid) return;

    // Remove any existing view classes
    grid.classList.remove('grid--view-1', 'grid--view-3', 'grid--view-5');

    // Only apply custom view on desktop
    if (!isMobile()) {
      grid.classList.add('grid--view-' + v);
    }

    if (toolbar) {
      toolbar.querySelectorAll('[data-view]').forEach(function (btn) {
        var active = btn.dataset.view === v;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
      });
    }

    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
  }

  /* ── read saved preference ───────────────────────────────────────── */
  function getSaved() {
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      return (v === '1' || v === '3' || v === '5') ? v : DEFAULT_VIEW;
    } catch (e) {
      return DEFAULT_VIEW;
    }
  }

  /* ── initial apply ───────────────────────────────────────────────── */
  function init() {
    var grid    = getGrid();
    var toolbar = getToolbar();
    if (grid) {
      applyView(getSaved(), grid, toolbar);
    }
  }

  // Run immediately if DOM is ready, else wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── toolbar button clicks ───────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-view]');
    if (!btn) return;
    // Make sure the click is on a toolbar view button (not something else with data-view)
    if (!btn.closest('#ic-grid-toolbar')) return;
    var grid    = getGrid();
    var toolbar = getToolbar();
    applyView(btn.dataset.view, grid, toolbar);
  });

  /* ── MutationObserver: re-apply after Shopify facet AJAX re-renders ─
     Shopify's facets.js replaces the innerHTML of #ProductGridContainer
     (or #product-grid-container) which wipes our view class.
     We observe the container and re-apply saved view when grid appears.
  ─────────────────────────────────────────────────────────────────── */
  function watchForGridChanges() {
    // Try both container IDs that Shopify/Dawn might use
    var container =
      document.getElementById('ProductGridContainer') ||
      document.getElementById('product-grid-container') ||
      document.querySelector('[data-id].collection');

    if (!container) {
      // Fallback: observe the body with subtree, but throttle
      container = document.body;
    }

    var reapplyTimer = null;

    var observer = new MutationObserver(function (mutations) {
      if (isMobile()) return;

      // Debounce to avoid firing many times during a single AJAX update
      clearTimeout(reapplyTimer);
      reapplyTimer = setTimeout(function () {
        var grid    = getGrid();
        var toolbar = getToolbar();
        if (grid && !grid.classList.contains('grid--view-' + getSaved())) {
          applyView(getSaved(), grid, toolbar);
        }
      }, 50);
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  watchForGridChanges();

  /* ── re-apply on browser back/forward (popstate) ───────────────── */
  window.addEventListener('popstate', function () {
    setTimeout(function () {
      var grid    = getGrid();
      var toolbar = getToolbar();
      if (grid && !isMobile()) applyView(getSaved(), grid, toolbar);
    }, 300);
  });

  /* ── re-apply on resize (crossing mobile breakpoint) ─────────────── */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var grid    = getGrid();
      var toolbar = getToolbar();
      if (grid) applyView(getSaved(), grid, toolbar);
    }, 150);
  });


  /* ════════════════════════════════════════════════════════════════════
     AJAX ADD-TO-CART for overlay buttons (.ic-overlay-btn[data-ic-overlay-add])
     ════════════════════════════════════════════════════════════════════ */

  function openCartDrawer() {
    // Dawn cart-drawer custom element
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }
    // Fallback: click cart icon
    var cartBubble = document.getElementById('cart-icon-bubble');
    if (cartBubble) cartBubble.click();
  }

  function refreshCartDrawer() {
    // Re-fetch the cart-drawer section to get updated HTML
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser  = new DOMParser();
        var doc     = parser.parseFromString(html, 'text/html');

        // Update CartDrawer contents
        var newInner = doc.getElementById('CartDrawer');
        var oldInner = document.getElementById('CartDrawer');
        if (newInner && oldInner) {
          oldInner.innerHTML = newInner.innerHTML;
        }

        // Update cart count bubble
        var newBubble = doc.querySelector('.cart-count-bubble');
        var oldBubble = document.querySelector('.cart-count-bubble');
        if (newBubble && oldBubble) {
          oldBubble.innerHTML = newBubble.innerHTML;
        } else if (newBubble) {
          var icon = document.getElementById('cart-icon-bubble');
          if (icon) icon.appendChild(newBubble.cloneNode(true));
        }
      })
      .catch(function () {});
  }

  function addToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var originalHTML = btn.innerHTML;
    btn.classList.add('ic--loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method:  'POST',
      headers: {
        'Content-Type':     'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed ' + res.status);
        return res.json();
      })
      .then(function () {
        btn.classList.remove('ic--loading');
        btn.classList.add('ic--success');
        btn.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"' +
          ' fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"' +
          ' stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
          ' Added!';

        // Refresh drawer then open
        refreshCartDrawer();
        setTimeout(openCartDrawer, 200);

        // Reset button after 2.5 s
        setTimeout(function () {
          btn.classList.remove('ic--success');
          btn.innerHTML = originalHTML;
          btn.disabled  = false;
        }, 2500);
      })
      .catch(function () {
        btn.classList.remove('ic--loading');
        btn.disabled  = false;
        btn.innerHTML = originalHTML;
        // Fallback: navigate to product page
        var wrapper = btn.closest('[data-product-url]');
        if (wrapper) window.location.href = wrapper.dataset.productUrl;
      });
  }

  // Delegated click for overlay add buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ic-overlay-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });

})();
